import { Gesture } from './gesture';
import { Pan } from './pan';
import { Press } from './press';
import { Swipe } from './swipe';
import { Tap } from './tap';
var MAP = {
    Pan: Pan,
    Press: Press,
    Swipe: Swipe,
    Tap: Tap,
};
export var getGesture = function (g) { return MAP[g]; };
export { Gesture };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g-gesture@1.0.0@@antv/g-gesture/esm/gestures/index.js
// module id = null
// module chunks = 